import { Small } from 'foundations-components/transitional/components/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error untyped dep
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Urls } from '../Constants';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExportDialogEmailHelpText = () => /*#__PURE__*/_jsx(Text, {
  as: "p",
  children: /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "exportDialog.allowlistHelpText_jsx",
      elements: {
        KBLink: KnowledgeBaseButton
      },
      options: {
        allowlistUrl: {
          url: Urls.allowlistUrl,
          className: 'm-all-0'
        },
        notificationUrl: {
          url: Urls.notificationUrl,
          className: 'm-all-0'
        }
      }
    })
  })
});